import React from 'react';
import { cn } from '@/lib/utils';

/**
 * Premium Badge Component - Swiss Luxury Aesthetic
 * Refined pills with subtle styling for status indicators
 * Removed animations for professional, calm aesthetic
 */
const Badge = React.forwardRef(({ className, variant = "default", size = "default", ...props }, ref) => {
  const variants = {
    // Default - Primary blue
    default: "bg-primary-50 text-primary-700 border-primary-200",

    // Success - High compliance
    success: "bg-success-50 text-success-700 border-success-200",

    // Warning - Medium compliance
    warning: "bg-warning-50 text-warning-700 border-warning-200",

    // Danger - Low compliance
    danger: "bg-danger-50 text-danger-700 border-danger-200",

    // Info
    info: "bg-info-50 text-info-700 border-info-200",

    // Neutral
    neutral: "bg-neutral-100 text-neutral-700 border-neutral-200",

    // Gradient - Premium accent
    gradient: "bg-gradient-to-r from-primary-500 to-accent-500 text-white border-transparent shadow-sm",

    // Outline
    outline: "bg-transparent text-neutral-700 border-neutral-300",
  };

  const sizes = {
    sm: "px-2 py-0.5 text-xs",
    default: "px-3 py-1 text-xs",
    lg: "px-4 py-1.5 text-sm",
  };

  return (
    <div
      ref={ref}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full font-medium border transition-colors duration-fast",
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    />
  );
});

Badge.displayName = "Badge";

export { Badge };
